/**
 * SportsLangContext — controla o idioma do painel Sports (RBAC/workspaces).
 * Persiste em localStorage como 'vukz_sports_lang'.
 * Uso:
 *   import { useSportsLang } from '../../contexts/SportsLangContext';
 *   const { lang, setLang } = useSportsLang();
 */
import React, { createContext, useContext, useState } from 'react';

const SportsLangContext = createContext({ lang: 'pt', setLang: () => {} });

export const SportsLangProvider = ({ children }) => {
  const [lang, setLangState] = useState(
    () => localStorage.getItem('vukz_sports_lang') || 'pt'
  );

  const setLang = (l) => {
    localStorage.setItem('vukz_sports_lang', l);
    setLangState(l);
  };

  return (
    <SportsLangContext.Provider value={{ lang, setLang }}>
      {children}
    </SportsLangContext.Provider>
  );
};

export const useSportsLang = () => useContext(SportsLangContext);

export default SportsLangContext;
